import { mutation } from '../graphql'
import { markDeliberateSpaceSwitch } from './space-auto-switch'

// Schreibpfad für active_space_id aus der Oberfläche (Switcher, Auswahllisten,
// automatischer Wechsel). Danach muss restartDashboard() laufen, der Token
// trägt den aktiven Standort erst nach dem Reload.
//
// Wechsel, die der Nutzer selbst auslöst, merken den Zielstandort als bewusst
// gewählt. Der automatische Wechsel ruft mit deliberate false und merkt nichts.
// Asynchron, damit auch ein synchroner Wurf von mutation() (fehlender
// Username) als Ablehnung ankommt.
export const switchActiveSpace = async ({
  userId,
  spaceId,
  deliberate = true
}) => {
  if (deliberate) markDeliberateSpaceSwitch({ user: userId, spaceId })

  return mutation({
    mutation: 'updateUser',
    input: { id: userId, active_space_id: spaceId, lastUpdatedBy: userId }
  })
}
